// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DOZLK","rootNoMargin":"styles_rootNoMargin__1pk5-"};